<template>
  <div class="info">
      <div class="head-wrap content-padding">
    </div>
    <div class="content-padding">
      <div class="section">
        <div class="content" style="margin-top:-40px">
          <div class="manage-info manage-info-repeat" v-for="(item, index) in form.itemList" :key="index">
            <div class="manage-info_content">
              <section class="section-content">
                <img class="sec-title" src="@/assets/shuLan/block-3.png" />
                <div class="input-wrap">
                  <div class="key">开始日期</div>
                  <div class="val">
                    <van-cell-group>
                      <van-cell
                        :title="form.itemList[index]['checkStartTime']"
                        @click="onHandleChoiceDate(index)"
                        :class="[{ link: !isLink }]"
                      >
                        <template #right-icon>
                          <img class="right-icon" src="@/assets/shuLan/icon-clock.png" />
                        </template>
                      </van-cell>
                      <van-calendar v-model="show" :min-date="minDate" @confirm="onConfirm" color="#07A8FF" />
                    </van-cell-group>
                  </div>
                </div>
                <div class="project-list">
                  <ul v-for="(listItem, listIndex) in list" :key="listIndex">
                    <li
                      v-for="projectItem in listItem"
                      :key="projectItem.id"
                      :class="[{ active: item.productList.find((p) => p.productId == projectItem.id) }]"
                      @click="onHandleChoice(index, projectItem)"
                    >
                      <p class="title">{{ projectItem.name }}</p>
                      <p class="title">{{ projectItem.tag }}</p>
                      <p class="middle"></p>
                      <p>￥{{ projectItem.label }}</p>
                      <div class="item-success" v-if="item.productList.find((p) => p.productId == projectItem.id)">
                        <img src="@/assets/shuLan/select.png" />
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <section class="money section-content" v-if="item.productList.length">
                <img class="sec-title" src="@/assets/shuLan/block-4.png" />
                <div v-for="(expendItem, expendIndex) in expendList" :key="expendIndex" class="money-info">
                  <div v-if="item.productList.find((p) => p.productId == expendItem.id)" class="money-info_content">
                    <span>{{ expendItem.name }}{{ expendItem.tag }}</span>
                    <span style="display: flex; align-items: center;">
                      ￥{{ expendItem.label }} &nbsp;&nbsp;
                      <van-stepper @change="stepperChange(index)" v-model="item.productList.find((p) => p.productId == expendItem.id).productCount" integer />
                    </span>
                  </div>
                </div>
                <div class="money-footer">
                  <span>总计</span>
                  <span>￥{{ item.sum }}</span>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="info-footer flex flex-between flex-align-center">
      <dl>
        <dt>总计</dt>
        <dd>￥{{ sum }}</dd>
      </dl>
      <div class="info-footer_right">
        <div class="pay-now btn" @click="onHandleSubmit"></div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40" vertical class="loadingDiv">支付中...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from "vant";
import { list, expendList, item } from "./config";
import { onSettleInfoSubmitShuLanDaoHuiLi } from "@/api";
import { weixinInit } from "@/utils/wechatUtil.js";

export default {
  data() {
    return {
      title: "请选择日期",
      isLink: true,
      show: false,
      loading: false,
      urlString: "",
      list,
      expendList,
      form: {
        payPersonName: "",
        payPersonNo: "",
        payPersonPhone: "",
        itemList: [JSON.parse(JSON.stringify(item))],
      },
      sum: 0,
      orgId: "",
      areaCode: "",
      currentItem: null,
      currentIndex: 0,
    };
  },
  created() {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    this.minDate = currentDate;
    this.orgId = localStorage.getItem("orgId") || "";
    this.areaCode = localStorage.getItem("areaCode") || "";
    this.urlString = window.location.href.split("#")[0];
    const form = localStorage.getItem("shuLanDaoHuiLi_cache");
    if (form) {
      this.form = JSON.parse(form);
      this.onGetTotalSum();
    }
    this.wxConfigInit();
  },
  methods: {
    onHandleChoiceDate(index) {
      this.currentIndex = index;
      this.currentItem = this.form.itemList[index];
      this.show = true;
    },
    onPad(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${this.onPad(date.getMonth() + 1)}-${this.onPad(date.getDate())}`;
    },
    onConfirm(date) {
      this.show = false;
      this.form.itemList[this.currentIndex]["checkStartTime"] = this.formatDate(date);
      this.isLink = false;
      this.title = this.form.itemList[this.currentIndex]["checkStartTime"];
    },
    async wxConfigInit() {
      await weixinInit({ publicType: 1, url: this.urlString });
    },
    async weixinPay(weixinPayParam) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady.bind(this, weixinPayParam), false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady.bind(this, weixinPayParam));
        }
      } else {
        this.onBridgeReady(weixinPayParam);
      }
    },
    async onBridgeReady(weixinPayParam) {
      let payNoDiy = weixinPayParam.payNo;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: weixinPayParam.appId,
          timeStamp: weixinPayParam.timeStamp,
          nonceStr: weixinPayParam.nonceStr,
          package: weixinPayParam.packages,
          signType: weixinPayParam.signType,
          paySign: weixinPayParam.paySign,
        },
        function () {
          localStorage.removeItem("shuLanDaoHuiLi_cache");
          window.location.href = "https://yisheng.healthmore.net/shuLanDaoHuiLiInfoSuccess?payNo=" + payNoDiy;
        }
      );
    },
    onHandleAdd() {
      this.form.itemList.push(JSON.parse(JSON.stringify(item)));
    },
    onHandleRemove(index) {
      if (this.form.itemList.length === 1) {
        Toast("至少保留一个用户信息");
        return;
      }
      this.form.itemList.splice(index, 1);
      this.onGetTotalSum();
    },
    onHandleChoice(index, item) {
      const selectIndex = this.form.itemList[index]["productList"].findIndex((p) => p.productId == item.id);
      if (selectIndex != -1) {
        this.form.itemList[index]["productList"].splice(selectIndex, 1);
      } else {
        this.form.itemList[index]["productList"].push({ productId: item.id, productCount: 1 });
      }
      this.onGetTotalSum();
    },
    stepperChange(listIdx) {
      let sum = 0;
      this.form.itemList[listIdx]["productList"].forEach((p) => {
        const found = this.expendList.find((e) => e.id == p.productId);
        sum += found.label * p.productCount;
      });
      this.form.itemList[listIdx]["sum"] = sum;
      this.onGetTotalSum();
    },
    onGetTotalSum() {
      this.sum = this.form.itemList.reduce((total, item) => {
        item.sum = item.productList.reduce((s, p) => {
          const found = this.expendList.find((e) => e.id == p.productId);
          return s + (found ? found.label * p.productCount : 0);
        }, 0);
        return total + item.sum;
      }, 0);
    },
    onHandleSubmit() {
      const list = this.form.itemList;
      for (let i = 0; i < list.length; i++) {
        if (!list[i].checkStartTime) { Toast("请选择开始日期"); return false; }
        if (!list[i].productList.length) { Toast("请至少选择一个项目"); return false; }
      }
      this.onHandleFinalSumit();
    },
    async onHandleFinalSumit() {
      if (this.loading) return;
      this.loading = true;
      let code = localStorage.getItem("code") || "";
      let values = {
        wxCode: code,
        saleOrgId: this.orgId,
        areaCode: this.areaCode,
        ...this.form,
      };
      try {
        const res = await onSettleInfoSubmitShuLanDaoHuiLi(values);
        if (res.code == 200) {
          this.weixinPay(res.data);
        } else {
          this.$toast(res.msg);
          this.loading = false;
        }
      } catch (err) {
        console.log("err", err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.section-content {
  background-color: #fff;
  border-radius: 16px;
  padding: 0 15px 15px;
  margin-bottom: 40px;
  .sec-title { position: relative; top: -20px; left: -15px; height: 45px; }
}
* { box-sizing: border-box; }
.head-img { width: 100%; max-width: 402px; margin-top: -30px; }
img { display: block; max-width: 100%; }
.head-wrap { padding: 0px 0 50px; overflow: hidden; }
.content-padding { padding-left: 20px; padding-right: 20px; }
.section {
  border-radius: 12px;
  margin-bottom: 16px;
  .content { padding-top: 20px; border-radius: 12px; }
}
.input-wrap {
  margin-bottom: 16px;
  .key { color: #363636; font-size: 14px; margin-bottom: 12px; }
  .val {
    /deep/ .van-cell { border: none; background-color: #EAF6FE; }
  }
}
/deep/ .right-icon { width: 18px; height: 18px; }
.loadingDiv { position: absolute; left: 42%; top: 40%; }
.info {
  position: relative;
  min-height: 100vh;
  padding-bottom: 100px;
  background-color: #BBDEFA;
  .manage-info {
    overflow: hidden;
    margin-bottom: 20px;
    &-repeat { background-repeat: repeat-y; background-size: 100% 100%; }
    &_content {
      padding-top: 20px;
      .link /deep/ .van-cell__title { color: #333; }
      /deep/ .van-cell::after { border-bottom: none; }
      .project-list {
        margin: -3px;
        ul {
          display: flex;
          margin-bottom: 6px;
          flex-wrap: wrap;
          li {
            width: auto;
            position: relative;
            border: 1px solid #B8D7EB;
            border-radius: 8px;
            padding: 6px 9px 4px;
            margin: 3px;
            &.active { border: 1px solid #0374C3; }
            .item-success {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 16px;
              height: 16px;
              img { position: absolute; width: 100%; height: 100%; }
            }
            p {
              font-size: 11px;
              color: rgb(255, 60, 28);
              margin: 8px 0;
              text-align: center;
              font-weight: 900;
              &.title { font-size: 11px; font-weight: 500; color: #363636; margin: 2px 0; }
              &.middle {
                margin: 10px 8px;
                height: 1px;
                background: url("../../assets/shuLan/line.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
      .money {
        &-info {
          &_content {
            display: flex;
            justify-content: space-between;
            margin: 14px 0;
            span {
              font-size: 13px;
              color: rgb(30, 30, 30);
              font-weight: 400;
              &:last-child { color: rgb(255, 60, 28); }
            }
          }
        }
        &-footer {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;
          border-top: 1px solid #EAF6FE;
          span {
            font-size: 16px;
            font-weight: 900;
            color: rgba(30, 30, 30);
            &:last-child { color: rgb(255, 60, 28); }
          }
        }
      }
    }
  }
  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 20px 12px 30px;
    dl {
      dt { font-size: 12px; color: #000; }
      dd { font-size: 18px; color: rgb(255, 60, 28); font-weight: 900; }
    }
    &_right {
      font-size: 16px;
      font-weight: 900;
      display: flex;
      .btn { width: 111px; height: 42px; background-size: contain; background-repeat: no-repeat; background-position: center; }
      .pay-now { background-image: url("../../assets/shuLan/btn-r.png"); padding: 7px 20px; }
    }
  }
}
.info {
  background-image: url("../../assets/shuLan/body-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
